import { apiCall } from "../../../services/api-service";

export const getVehicleDetailAPI = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const getVehicleAssignDetAPI = (id) =>
  apiCall("get", `vehicle_assignment/edit/${id}`);

export const submitAPI = (body) =>
  apiCall("post", "vehicle_assignment", body);

export const UpdateAPI = (body, id) =>
  apiCall("put", `vehicle_assignment/${id}`, body);